/**
 * Reserved slug used to indicate the system default agency.
 * The backend interprets this slug as "use the default agency".
 */
export const DEFAULT_AGENCY_SLUG = 'default'

export const RESERVED_AGENCY_SLUG_LIST = [DEFAULT_AGENCY_SLUG] as const
